import { render } from "./OwnedProperties.vue?vue&type=template&id=5e794036"
import script from "./OwnedProperties.vue?vue&type=script&lang=js"
export * from "./OwnedProperties.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__